import React from "react";

const Address = () => {
  return (
    <>
      <div className="ptf-animated-block" data-aos="fade" data-aos-delay="100">
        <h5 className="fz-14 text-uppercase has-3-color fw-normal">Email</h5>
        <div className="ptf-spacer" style={{ "--ptf-xxl": "1.25rem" }} />
        <p className="fz-20 lh-1p5 has-black-color">
          <a href="mailto:support@githubit.com">support@githubit.com</a>
        </p>
      </div>

      <div className="ptf-spacer" style={{ "--ptf-xxl": "2.1875rem" }} />

      <div className="ptf-animated-block" data-aos="fade" data-aos-delay="200">
        <h5 className="fz-14 text-uppercase has-3-color fw-normal">Phone</h5>
        <div className="ptf-spacer" style={{ "--ptf-xxl": "1.25rem" }} />
        <p className="fz-20 lh-1p5 has-black-color">
          <a href="tel:+12023401032">+1 202 3401032</a>
        </p>
      </div>

      <div className="ptf-spacer" style={{ "--ptf-xxl": "2.1875rem" }} />

      <div className="ptf-animated-block" data-aos="fade" data-aos-delay="0">
        <h5 className="fz-14 text-uppercase has-3-color fw-normal">Address</h5>
        <div className="ptf-spacer" style={{ "--ptf-xxl": "1.25rem" }} />
        <p className="fz-20 lh-1p5 has-black-color">
          90 Fairground Rd St FL 3290
          <br />
          United States
        </p>
      </div>

      <div
        className="ptf-spacer"
        style={{ "--ptf-lg": "4.375rem", "--ptf-md": "2.1875rem" }}
      />
    </>
  );
};

export default Address;
